import React from "react";
import { websiteBuilderGenerateVideoDesignStyles, IWebsiteBuilderVideo } from "pages/secure/facility/websiteBuilder/editor/nodes/element/websiteBuilderVideo";
import classNames from "classnames";

interface IWebsiteBuilderVideoViewProps {
  node: IWebsiteBuilderVideo;
}

export function WebsiteBuilderVideoView(props: IWebsiteBuilderVideoViewProps) {
  const { node } = props;

  const settings = node.element.settings;
  const designStyles = websiteBuilderGenerateVideoDesignStyles(settings);

  return (
    <div className={designStyles.containerClassName}>
      {settings.src && (
        <video
          className={classNames(designStyles.className, "editor-video")}
          src={settings.src}
          preload="metadata"
          muted
          playsInline
          disablePictureInPicture
        />
      )}
    </div>
  );
}
